import { getCityDimensions } from '../../pages/best-companies/dimensionConfig';
import { getAllCitySlugs, getCityDataBySlug } from '../location/finland-hub-config';
import { sanitizeForUrl } from '../routing/generate-url';

/**
 * City name (any locale, ASCII-folded lowercase: "tampere", "tammerfors", "jyvaskyla") ->
 * employers city page slug (`/fi/tyonantajat/{slug}`), for the cities that have one. Built from
 * the curated Finland hub cities so Swedish exonyms map too; a city without an employers page
 * simply has no entry.
 */
function build(): Map<string, string> {
  const dimensionSlugs = new Set(getCityDimensions(false).map((d) => d.slug));
  const map = new Map<string, string>();
  for (const hubSlug of getAllCitySlugs()) {
    const english = hubSlug.split('_')[0];
    const dim = sanitizeForUrl(english);
    if (!dimensionSlugs.has(dim)) continue;
    for (const locale of ['en', 'fi', 'sv'] as const) {
      const name = getCityDataBySlug(hubSlug, locale)?.name;
      if (name) map.set(sanitizeForUrl(name), dim);
    }
    map.set(dim, dim);
  }
  return map;
}

export const EMPLOYERS_CITY_SLUGS: Map<string, string> = build();

/** Employers city page slug for a city display name in any locale, or null. */
export function employersCitySlugForCity(cityName: string | null | undefined): string | null {
  const key = sanitizeForUrl((cityName ?? '').split(',')[0]);
  return key ? EMPLOYERS_CITY_SLUGS.get(key) ?? null : null;
}

/** Curated Finland hub slug ("Tampere_Finland") behind an employers city page slug ("tampere"), or null. */
export function finlandHubSlugForEmployersCitySlug(citySlug: string): string | null {
  const wanted = citySlug.trim().toLowerCase();
  if (!wanted) return null;
  for (const hubSlug of getAllCitySlugs()) {
    if (sanitizeForUrl(hubSlug.split('_')[0]) === wanted) return hubSlug;
  }
  return null;
}
